import { throttle } from "kwp-core/scripts/utils/helpers";

export default () => {
    const adminPreview = document.body.classList.contains("admin-bar");

    if (adminPreview) {
        updateHeaderOffset();
    }
    window.addEventListener(
        "resize",
        throttle(() => {
            if (adminPreview) {
                updateHeaderOffset();
            }
        }, 250)
    );

    function updateHeaderOffset() {
        const wpMenuBar = document.getElementById("wpadminbar");
        if (wpMenuBar) {
            const wpMenuBarHeight = wpMenuBar ? wpMenuBar.offsetHeight : 0;
            const rootElement = document.documentElement;
            rootElement.style.setProperty(
                "--offsetTop",
                `${wpMenuBarHeight}px`
            );
        }
    }
};
